import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { meetingApis } from '@/features/meetings/meetings.query';
import { meetingStore } from '@/features/meetings/meetings.state';
import { littlebirdSdk } from '@/lib/sdk-init';
import { inElectron } from '@/utils';

export const Route = createFileRoute('/_authenticated/meetings/')({
  validateSearch: z.object({
    start: z.string().optional(),
    settings: z.coerce.boolean().optional(),
  }).parse,
  onEnter() {
    meetingStore.setMeetingNotesOnboarded(true);
    meetingStore.meetingStartedFromOverview = false;
    if (inElectron()) meetingApis.getMacPermissions();
    void littlebirdSdk.stores.meetings.ensureListLoadedFromStorage();
  },
  onLeave() {
    meetingStore.meetingStartedFromOverview = false;
  },
});
